import { FunctionComponent } from 'react'
import { RFPSortBy } from '@black-bear-energy/black-bear-energy-common'
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  rucksack,
} from '@black-bear-energy/rucksack'
import { SwapVertRounded } from '@mui/icons-material'
import { MenuButton } from '../common/MenuButton'
import { MenuButtonSection } from '../common/MenuButtonSection'

export const SortButton: FunctionComponent<SortButtonProps> = ({
  sortBy,
  setSortBy,
  sortAsc,
  setSortAsc,
  handleReset,
  resetDisabled,
}) => {
  const handleSortByChange = (
    event: React.MouseEvent<HTMLElement>,
    value: RFPSortBy
  ) => {
    // Ensure at least one sortBy value is always active.
    if (value !== null && value !== undefined) {
      setSortBy(value)
    }
  }
  const handleSortAscChange = (
    event: React.MouseEvent<HTMLElement>,
    value: boolean
  ) => {
    // Ensure at least one sortAsc value is always active.
    if (value !== null && value !== undefined) {
      setSortAsc(value)
    }
  }

  return (
    <MenuButton
      label={`sort by: ${SortByDisplayName[sortBy]} (${
        sortAsc ? 'asc' : 'desc'
      })`}
      icon={<SwapVertRounded />}
      align="right"
      reset={{ handleReset, resetDisabled }}
    >
      <Box component="li" sx={{ py: 1 }}>
        <MenuButtonSection title="Sort By">
          <ToggleButtonGroup
            value={sortBy}
            exclusive
            onChange={handleSortByChange}
            size="small"
            sx={{
              py: '0.375rem',
              '& .MuiButtonBase-root': {
                color: rucksack.palette.text.primary,
              },
            }}
          >
            <ToggleButton value={RFPSortBy.RFPName}>
              {SortByDisplayName.rfpName}
            </ToggleButton>
            <ToggleButton value={RFPSortBy.SystemSize}>
              {SortByDisplayName.systemSize}
            </ToggleButton>
            <ToggleButton value={RFPSortBy.LastUpdated}>
              {SortByDisplayName.lastUpdated}
            </ToggleButton>
          </ToggleButtonGroup>
        </MenuButtonSection>
        <MenuButtonSection title="Order">
          <ToggleButtonGroup
            value={sortAsc}
            exclusive
            onChange={handleSortAscChange}
            size="small"
            sx={{
              py: '0.375rem',
              '& .MuiButtonBase-root': {
                color: rucksack.palette.text.primary,
              },
            }}
          >
            <ToggleButton value={true}>Ascending</ToggleButton>
            <ToggleButton value={false}>Descending</ToggleButton>
          </ToggleButtonGroup>
        </MenuButtonSection>
      </Box>
    </MenuButton>
  )
}

export interface SortButtonProps {
  sortBy: RFPSortBy
  setSortBy: (sortBy: RFPSortBy) => void
  sortAsc: boolean
  setSortAsc: (sortAsc: boolean) => void
  handleReset: () => void
  resetDisabled: boolean
}

enum SortByDisplayName {
  rfpName = 'project name',
  systemSize = 'system size',
  lastUpdated = 'last updated',
}
